import React from 'react';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'active';
  ariaLabel: string;
  className?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({ 
  icon,
  size = 'md', 
  variant = 'default',
  ariaLabel,
  className = '',
  ...props 
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-8 h-8 p-1.5';
      case 'md':
        return 'w-10 h-10 p-2';
      case 'lg':
        return 'w-12 h-12 p-2.5';
      default:
        return 'w-10 h-10 p-2';
    }
  };

  const getVariantClasses = () => {
    switch (variant) {
      case 'active':
        return 'bg-game-golden text-white shadow-md shadow-game-golden/20 hover:bg-game-accent';
      case 'default':
      default:
        return 'bg-game-medium/30 border border-game-medium/50 text-gray-300 hover:bg-game-medium/50 hover:text-white hover:border-game-light/50';
    }
  };

  const baseClasses = 'transition-all duration-200 flex items-center justify-center rounded-lg group disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md hover:shadow-game-medium/20';
  const sizeClasses = getSizeClasses();
  const variantClasses = getVariantClasses();
  const finalClassName = `${baseClasses} ${sizeClasses} ${variantClasses} ${className}`.trim();

  return (
    <button 
      className={finalClassName}
      aria-label={ariaLabel}
      title={ariaLabel}
      type="button"
      {...props}
    >
      {icon}
    </button>
  );
};